<script lang="ts">
    import { duplicateUserConnectedStore } from "../../Stores/DuplicateUserConnectedStore";
    import { LL } from "../../../i18n/i18n-svelte";
    import { localUserStore } from "../../Connection/LocalUserStore";
    import InputCheckbox from "../Input/InputCheckbox.svelte";

    let dontRemindAgain = $state(false);

    function confirmAndContinue() {
        if (dontRemindAgain) {
            try {
                localUserStore.setDuplicateUserDontRemind(true);
            } catch {
                console.error("Failed to set DUPLICATE_USER_DONT_REMIND_KEY");
            }
        }
        duplicateUserConnectedStore.setDuplicateConnected(false);
    }
</script>

{#if $duplicateUserConnectedStore}
    <div
        class="fixed inset-0 z-9999 flex items-center justify-center bg-mdark/50 p-4 backdrop-blur-md pointer-events-auto"
        role="alertdialog"
        aria-labelledby="duplicate-user-title"
        aria-describedby="duplicate-user-message"
    >
        <div
            class="w-full max-w-md rounded-md2 bg-mlight/80 shadow-light backdrop-blur-md p-6 text-mdark"
            role="document"
            data-testid="duplicate-user-modal"
        >
            <h3 id="duplicate-user-title" class="text-center">
                {$LL.warning.duplicateUserConnected.title()}
            </h3>
            <p id="duplicate-user-message" class="mt-4 text-sm text-mdark/75">
                {$LL.warning.duplicateUserConnected.message()}
            </p>
            <div class="mt-2 -ml-2">
                <InputCheckbox
                    bind:value={dontRemindAgain}
                    label={$LL.warning.duplicateUserConnected.dontRemindAgain()}
                    data-testid="duplicate-user-dont-remind-again"
                />
            </div>
            <div class="mt-4 flex justify-center">
                <button
                    type="button"
                    class="btn btn-secondary justify-center w-full sm:w-auto"
                    onclick={confirmAndContinue}
                    data-testid="duplicate-user-confirm-continue"
                >
                    {$LL.warning.duplicateUserConnected.confirmContinue()}
                </button>
            </div>
        </div>
    </div>
{/if}
